var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4206 15.5993C28.6063 15.5993 31.9994 12.2019 31.9994 8.01107C31.9994 3.82021 28.6063 0.422852 24.4206 0.422852C20.2349 0.422852 16.8418 3.82021 16.8418 8.01107C16.8418 12.2019 20.2349 15.5993 24.4206 15.5993Z",
    fill: "#45436B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2081 0.422852H2.94957C1.32057 0.422852 0 1.74506 0 3.37608V12.6461C0 14.2771 1.32057 15.5993 2.94957 15.5993H12.2081C13.8371 15.5993 15.1576 14.2771 15.1576 12.6461V3.37608C15.1576 1.74506 13.8371 0.422852 12.2081 0.422852Z",
    fill: "#45436B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2081 17.2861H2.94957C1.32057 17.2861 0 18.6083 0 20.2394V29.5093C0 31.1404 1.32057 32.4626 2.94957 32.4626H12.2081C13.8371 32.4626 15.1576 31.1404 15.1576 29.5093V20.2394C15.1576 18.6083 13.8371 17.2861 12.2081 17.2861Z",
    fill: "#45436B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0499 17.2861H19.7914C18.1624 17.2861 16.8418 18.6083 16.8418 20.2394V29.5093C16.8418 31.1404 18.1624 32.4626 19.7914 32.4626H29.0499C30.6789 32.4626 31.9994 31.1404 31.9994 29.5093V20.2394C31.9994 18.6083 30.6789 17.2861 29.0499 17.2861Z",
    fill: "#45436B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.545427e8b5c3dd6778ef771cc248d62b.svg";
export { ForwardRef as ReactComponent };